import * as Constants from '../Redux/action_types/EPAConstants';

//ITG
// export const _serviceUrl = 'https://i2wg552788.it.hpe.com/Services/';
// export const _appUrl = 'https://i2wg552788.it.hpe.com/EPAvNextSizer/';
// export const _basename = '/EPAvNextSizer';

//Production
//export const _serviceUrl = 'https://solutionsizers.ext.hpe.com/Services/';
//export const _appUrl = 'https://solutionsizers.ext.hpe.com/EPASizer/';
//export const _basename = '/EPASizer';

// export const _serviceUrl = 'http://192.168.43.245:89/Services/';

const _baseUrl = window.location.protocol+'//'+window.location.host;
export const _serviceUrl = _baseUrl+'/Services/';
export let _appUrl;
let isHPECP = false;
if (window.location.href.toUpperCase().indexOf(Constants.HPECP_SIZER.toUpperCase()) > -1) {
  isHPECP = true;
  _appUrl = _baseUrl+'/EzmeralCPSizer/';
} else {
  _appUrl = _baseUrl+'/EPASizer/';
}
export const _version = '20.8.0';
export const _said = 'EPAvNext';
export let _title = 'HPE Sizing Tool for the Elastic Platform for Analytics (EPA)';
export let _basename = '/EPASizer';
if (isHPECP) {
  _basename = '/EzmeralCPSizer';
  _title = 'HPE Sizing Tool for Ezmeral ' + Constants.RE ;
}
export const _landingUrl = '213190_SIZERS_PRO_HPE';



// WEBPACK FOOTER //
// ./src/SizerUI/SizerConfig/Config.js